import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCbp } from "../services/api";

export const getCbp = createAsyncThunk("cbp/fetchCbp", async (page) => {
  const response = await fetchCbp(page);
  return response;
});

const cbpSlice = createSlice({
  name: "cbp",
  initialState: { data: [], status: "idle" },
  extraReducers: (builder) => {
    builder
      .addCase(getCbp.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCbp.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getCbp.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default cbpSlice.reducer;
